var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsnewMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.12 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-whatsnew-mapping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 4.41,
    width: 1.76,
    height: 22.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.24,
    y: 1.76,
    width: 15.88,
    height: 7.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.24,
    y: 12.35,
    width: 15.88,
    height: 7.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.24,
    y: 22.94,
    width: 15.88,
    height: 7.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.88,
    y: 4.41,
    width: 7.06,
    height: 1.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.76,
    y: 25.59,
    width: 12.35,
    height: 1.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.62 10.59 6.62 0 13.23 5.29 6.62 10.59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsnewMapping);
export default __webpack_public_path__ + "static/media/icon-whatsnew-mapping.0252c35f36d03f2fb995d75a4cfa103a.svg";
export { ForwardRef as ReactComponent };